import { FaroCoreApiTypes } from "@stellar/core-api-client";

/** A SCENE seat that can be added on top of an existing Sphere XG Point Cloud plan */
export interface SceneSeat {
  /** Identifier of the feature that is granted by the created plan */
  identifier: FaroCoreApiTypes.FeatureId;

  /** Human readable name of the license, shown when selecting the licenses to add */
  name: string;

  /** Label of the plan that is created for this license */
  planLabel: string;
}

export const SCENE_SEAT_IDENTIFIER: FaroCoreApiTypes.FeatureId = "scene-seat";

export const SCENE_SEAT_LABEL = "SCENE seat for a company member";

/** Name used wherever the number of SCENE seats of a plan is shown to the user */
export const SCENE_SEATS_DISPLAY_NAME = "SCENE Seats";

/** Name used when a plan comes with a single SCENE seat */
export const SCENE_SEAT_DISPLAY_NAME = "SCENE Seat";

/**
 * All the SCENE seats that can be added to a Sphere XG Point Cloud plan.
 * Only the seat license exists for now, but more licenses are expected to be added later.
 */
export const SCENE_SEATS: readonly SceneSeat[] = [
  {
    identifier: SCENE_SEAT_IDENTIFIER,
    name: "SCENE Seat",
    planLabel: SCENE_SEAT_LABEL,
  },
];
